import React, { createContext, useContext, useReducer } from 'react';
import { PHASES } from '../utils/gameRules';

const GameContext = createContext(null);

const SESSION_KEY = 'golf_session';

function loadRoomCode() {
  try {
    const raw = localStorage.getItem(SESSION_KEY);
    return raw ? JSON.parse(raw).roomCode || null : null;
  } catch {
    return null;
  }
}

function saveRoomCode(code) {
  try {
    const raw = localStorage.getItem(SESSION_KEY);
    const data = raw ? JSON.parse(raw) : {};
    data.roomCode = code;
    localStorage.setItem(SESSION_KEY, JSON.stringify(data));
  } catch {}
}

function clearRoomCode() {
  try {
    const raw = localStorage.getItem(SESSION_KEY);
    if (raw) {
      const data = JSON.parse(raw);
      delete data.roomCode;
      localStorage.setItem(SESSION_KEY, JSON.stringify(data));
    }
  } catch {}
}

const initialState = {
  roomCode: loadRoomCode(),
  gameState: {
    phase: PHASES.LOBBY,
    currentRound: 0,
    totalRounds: 9,
  },
  players: {},
  playerOrder: [],
  currentTurn: null,
  discardPile: { topCard: null, count: 0 },
  deckRemaining: 0,
  roundState: null,
  cardBack: 'classic',
};

function gameReducer(state, action) {
  switch (action.type) {
    case 'SET_ROOM_CODE':
      saveRoomCode(action.payload);
      return { ...state, roomCode: action.payload };

    case 'SYNC_GAME_STATE':
      return { ...state, ...action.payload };

    case 'SET_PHASE':
      return {
        ...state,
        gameState: { ...state.gameState, phase: action.payload },
      };

    case 'UPDATE_PLAYERS':
      return { ...state, players: action.payload };

    case 'UPDATE_CURRENT_TURN':
      return { ...state, currentTurn: action.payload };

    case 'UPDATE_DISCARD':
      return { ...state, discardPile: action.payload };

    case 'UPDATE_DECK_COUNT':
      return { ...state, deckRemaining: action.payload };

    case 'UPDATE_ROUND_STATE':
      return { ...state, roundState: action.payload };

    case 'RESET':
      clearRoomCode();
      return { ...initialState, roomCode: null };

    default:
      return state;
  }
}

function GameProvider({ children }) {
  const [state, dispatch] = useReducer(gameReducer, initialState);

  return (
    <GameContext.Provider value={{ state, dispatch }}>
      {children}
    </GameContext.Provider>
  );
}

function useGame() {
  const context = useContext(GameContext);
  if (!context) {
    throw new Error('useGame must be used within a GameProvider');
  }
  return context;
}

export { GameProvider, useGame };
